import {useEffect, useState} from 'react';
import {useParams} from 'react-router';
import {getUserDetails, setUserActive, setUserPermission} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";
import {Card, Row, Col, Checkbox, Divider, Popover, message} from 'antd';
import {DepartmentChangeWidget} from "./DepartmentChangeWidget";
import {UserActiveWidget} from "./UserActiveWidget";
import {PasswordInput} from "./PasswordInput";

export const UserView = ({onApiFail, refresh, onRefresh, props}) => {
    const params = useParams();
    const {userId} = params;
    const [user, setUser] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getUserDetails(userId).then(r => {
            setUser(r);
        }).catch(e => {
            handleNoSession(e,onApiFail);
        })
    }, [userId, onApiFail, refresh]);

    const onPermChange = (permission) => (e) => {
        setUserPermission(userId, permission, e.target.checked).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            handleNoSession(e, onApiFail);
        })
    }

    const setActive = (val) => {
        setUserActive(userId, val).then(r => {
            if (onRefresh) { onRefresh() }
            messageApi.open({
                type: 'success',
                content: val ? `User is Active` : `User is Disabled`
            })
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });
    }


    if (user === undefined) {
        return <div />
    }

    const rowStyle= {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const toBool = (val) => (val) ? true : false;

    return <div style={{textAlign: 'left'}}>
        {contextHolder}
        <Card title={<b>User</b>}>
            <Row style={rowStyle}>
                <Col span={2}>
                    <b>Username:</b>
                </Col>
                <Col>
                    {user.username}
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}>
                    <b>Firstname:</b>
                </Col>
                <Col>
                    {user.firstname}
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}>
                    <b>Lastname:</b>
                </Col>
                <Col>
                    {user.lastname}
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}>
                    <b>Email:</b>
                </Col>
                <Col>
                    {user.email}
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={2}>
                    <b>Active:</b>
                </Col>
                <Col>
                    <UserActiveWidget active={user.active} setActive={setActive} />
                </Col>
            </Row>
        </Card>
        <Card title={<b>Password</b>}>
            <PasswordInput user={user} onApiFail={onApiFail}/>
        </Card>
        <Card title={<b>Permissions</b>}>

            <Row style={rowStyle}>
                <Col span={2} style={{marginTop: '5px'}}>
                    <b>Department:</b>
                </Col>
                <Popover content={`Changing the Department will reset the user's default permissions`}>
                <Col>
                    <DepartmentChangeWidget user={user} onRefresh={onRefresh} onApiFail={onApiFail} refresh={refresh} />
                </Col>
                </Popover>
            </Row>
            <Divider />
            {  Object.entries(user.permissions).map(([key, val]) => {
                return <Row style={rowStyle} key={`${key}`}>
                    <Checkbox checked={toBool(val)} onChange={onPermChange(key)}>{key}</Checkbox>
                </Row>
            })
            }
        </Card>
    </div>
}